// extracted by mini-css-extract-plugin
module.exports = {"organizerStatsPreview":"organizer-stats-preview_organizerStatsPreview__1trgl"};